
    <svg:path [attr.d]="path" stroke-linecap="round" marker-end="url(#ConnectionHead)" stroke-width="1"
              [attr.stroke-dasharray]="valid ? '0, 0' : '10, 10'"
              [attr.stroke]="strokeFill"/>

    <svg:g *ngIf="!edge.triggered && (toVertexSelected || fromVertexSelected)" [attr.transform]="nameTransform">
      <rect [attr.x]="nameX" [attr.y]="nameY" [attr.width]="nameWidth" [attr.height]="nameHeight"
            [attr.fill]="strokeFill"
            rx="5" ry="5"/>
      <svg:text x="0" [attr.y]="valueFontSize / 4 + 1" font-family="monospace" font-weight="bold"
                [attr.font-size]="valueFontSize + 'px'"
                text-anchor="middle" fill="#fff">
        {{ nameText }}
      </svg:text>
    </svg:g>

    <svg:g *ngIf="edge.triggered" [attr.transform]="valueTransform">
      <rect [attr.x]="valueX" [attr.y]="valueY" [attr.width]="valueWidth" [attr.height]="valueHeight" fill="#D3234E"
            rx="5" ry="5"/>
      <svg:text x="0" [attr.y]="valueFontSize / 4 + 1" font-family="monospace" font-weight="bold"
                [attr.font-size]="valueFontSize + 'px'"
                text-anchor="middle" fill="#fff">
        {{ valueToShow }}
      </svg:text>
    </svg:g>
  


// WEBPACK FOOTER //
// ./src/library/graph/edge/workflow-graph-edge.component.ts.WorkflowGraphEdgeComponent.html